import HighlightedText from '@/components/HighlightedText';
import { Badge } from '@/components/ui/badge';
import { STATUS_MAP } from '@/constants';

const StatusBadge = ({ status, query }) => {
  const statusItem = STATUS_MAP[status];
  const StatusIcon = statusItem?.icon;

  if (!statusItem) return '-';

  return (
    <Badge className="gap-1" variant={statusItem.variant}>
      {StatusIcon && <StatusIcon className="h-5 w-5" />}
      <HighlightedText text={statusItem.text} query={query} />
    </Badge>
  );
};

export default StatusBadge;
